import React, { useState , useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Container,
  Row,
  Progress,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Card, CardBody, CardTitle,
} from "reactstrap";
import ApexChatSTicket from "../../../components/chats/ApexChatSTicket";
import Widget from "../../../components/Widget/Widget";
import { FcViewDetails , FcVoicePresentation ,FcAlarmClock , FcCancel , FcExpired , FcNews , FcConferenceCall , FcDocument , FcApproval ,FcBusinessman ,FcCalendar , FcBriefcase ,FcPaid  } from "react-icons/fc";
import { css } from "@emotion/react";
import { ClockLoader } from "react-spinners";
import "../Dashboard.css"
import BaseAPI from "../../../api/apiurl"
import  TaskWeeklyChat from "../../../components/chats/ApexPWeeklyCopy";
import StaffChatService from "../../../components/chats/ApexChatSP";
import ServiceOverAll from "../../../components/chats/ApexChatSPover";

const ServiceDashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [registered, setRegistered] = useState(null);
  const [open, setOpen] = useState(null);
  const [assigned, setAssigned] = useState(null);
  const [planned, setPlanned] = useState(null);
  const [inprogress, setInprogress] = useState(null);
  const [resolved, setResolved] = useState(null);
  const [closed, setClosed] = useState(null);
  const [staff, setStaff] = useState(null);


 const Dashboardcount = () =>{
   
    const company_id = localStorage.getItem('companyid');
    const customer_id = localStorage.getItem('customerid');

    if (company_id && customer_id) {
    
      const apiUrl = `${BaseAPI}servicedash?company_id=${company_id}&customer_id=${customer_id}`;

      // Make an HTTP GET request using fetch
      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error('Failed to fetch data');
          }
        })
        .then((data) => {

          setDashboardData(data);
          setRegistered(data.data[0].registered);
          setOpen(data.data[0].open);
          setAssigned(data.data[0].assigned);
          setPlanned(data.data[0].planned);
          setInprogress(data.data[0].inprogress);
          setClosed(data.data[0].closed);
          setResolved(data.data[0].resolved);
          setStaff(data.data[0].usercount);
        })
        .catch((error) => {
          console.log (error);
        });
    } else {
      console.log ('company_id and customer_id not found in local storage');
    }
  }


  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
      
   },2000);
  
   return () => clearTimeout(loadingTimeout), Dashboardcount(); 
  }, []);

  return (
    <div>
    {isLoading ? (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <ClockLoader color={"#4e73df"} loading={isLoading} css={spinnerStyle} size={100} /> 
      </div>
    ) : (
      
<div className="header bg-gradient-info pb-8 pt-md-8">
<br/>
        <Container fluid>
          <div className="header-body">         
            <Row className="no-gutters align-items-cente" >
              <Col lg="4" xl="2">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px'}}
                          className="text-muted mb-0"
                        >
                          Registered
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                        {registered !== null ? registered : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect" >
                        {/* <a href="/timeinlive/ServiceRegistered"><FcViewDetails style={{ fontSize: 30  }} /></a> */}
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ServiceRegistered"}>
                    <FcViewDetails style={{ fontSize: 30  }} />
                    </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" xl="2">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px'}}
                          className=" text-muted mb-0"
                        >
                          Assigned
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                        
                         {assigned !== null ? assigned : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect">
                        {/* <a href="/timeinlive/ServiceAssigned"><FcVoicePresentation style={{ fontSize: 30  }} /></a> */}
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ServiceAssigned"}>
                    <FcVoicePresentation style={{ fontSize: 30  }} />
                    </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" xl="2">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px'}}
                          className=" text-muted mb-0"
                        >
                          Planned
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                         
                          {planned !== null ? planned : '0'}
                        </span>
                      </div>
                      <Col className="col-auto" style={{height: '20px'}}>
                        <div className="zoom-in-effect">
                        {/* <a href="/timeinlive/ServicePlanned"><FcBriefcase style={{ fontSize: 30  }} /></a> */}
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ServicePlanned"}>
                    <FcBriefcase style={{ fontSize: 30  }} />
                    </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" xl="2">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px'}}
                          className=" text-muted mb-0" 
                        >
                          In-Progress
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                       
                        {inprogress !== null ? inprogress : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                      <div className="zoom-in-effect">
                      {/* <a href="/timeinlive/ServiceRescheduled"><FcExpired style={{ fontSize: 45 }} /></a> */}
                      <a href={process.env.PUBLIC_URL + "#/timeinlive/ServiceRescheduled"}>
                    <FcExpired style={{ fontSize: 30 }} />
                    </a>
                      </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" xl="2">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px'}}
                          className="text-muted mb-0"
                        >
                          Resolved
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                          
                          {resolved !== null ? resolved : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect">
                      {/* <a href="/timeinlive/ServiceResolve"><FcPaid style={{ fontSize: 30  }} /></a> */}
                      <a href={process.env.PUBLIC_URL + "#/timeinlive/ServiceResolve"}>
                    <FcPaid style={{ fontSize: 30  }} />
                    </a>
                    </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="4" xl="2">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '15px'}} 
                          className="text-muted mb-0"
                        >
                          Closed
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                     
                        {closed !== null ? closed : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect">
                        {/* <a href="/timeinlive/ServiceClosed"><FcCancel style={{ fontSize: 30  }} /></a> */}
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ServiceClosed"}>
                    <FcCancel style={{ fontSize: 30  }} />
                    </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              {/* <Col lg="4" xl="2">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '12px'}} 
                          className="text-muted mb-0"
                        >
                          Re-Open
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                         
                          {open !== null ? open : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect" >
                      
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/ServiceReOpen"}>
                    <FcNews style={{ fontSize: 30  }} />
                    </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                &nbsp; &nbsp; &nbsp;
              </Col> */}
              {/* <Col lg="4" xl="2">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          style={{fontSize: '12px'}} 
                          className="text-muted mb-0"
                        >
                          User
                        </CardTitle>
                        <span className="h4 font-weight-bold mb-0">
                      
                      {staff !== null ? staff : '0'}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="zoom-in-effect">
                       
                        <a href={process.env.PUBLIC_URL + "#/timeinlive/User"}>
                    <FcConferenceCall style={{ fontSize: 30  }} />
                    </a>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                &nbsp; &nbsp; &nbsp;
              </Col> */}
            </Row>
          </div>
          &nbsp; &nbsp; &nbsp;
          <div className="header-body">
            <Row>
             
              <Col className="pl-grid-col pr-grid-col" xs={6} lg={6}>
          <Row className="gutter mb-4 pl-grid-row pr-grid-row">
            <Col xs={12} xl={12}>
              <Widget className="widget-p-md" style={{ height: "500px", overflowY: "auto" , overflowX: "auto" }}>
                <div className="headline-2 mb-3" style={{ textAlign :"center"}}>Number of Monthly Services</div>
                <ApexChatSTicket/>
              </Widget>
            </Col>  
            <Col xs={12} xl={12}>
              <Widget className="widget-p-md">
                <div className="headline-2 mb-3" style={{ textAlign :"center"}}>Service Details </div>
                <StaffChatService />
              </Widget>
            </Col>
          </Row>
        </Col>
        <Col className="pl-grid-col pr-grid-col" xs={6} lg={6}>
          <Row className="gutter mb-4 pl-grid-row pr-grid-row">
          <Col xs={12} xl={12}>
  <Widget className="widget-p-md" style={{ height: "500px", overflowY: "auto" , overflowX: "auto" }}>
    <div className="headline-2 mb-3" style={{ textAlign: "center" }}>Service Log Per User</div>
    <TaskWeeklyChat />
  </Widget>
</Col>

            <Col xs={12} xl={12}>
              <Widget className="widget-p-md">
                <div className="headline-2 mb-3" style={{ textAlign :"center"}}>Overall Products in Service</div>
                <ServiceOverAll />
              </Widget>
            </Col>
          </Row>
        </Col>
            </Row>
          </div>
        </Container>
      </div>
      	)}
        </div>
  )
}

const spinnerStyle = css`
display: block;
margin: 0 auto;
`;

export default ServiceDashboard;
